/**
 * Does Guesty's calendar reach us complete for this home?
 *
 * THE PRODUCT OWNER'S RULE, 2026-09-25 (#57):
 *
 *   "gesty停用的房子不出现在listing上，这是正确的。但是我必须要知道有这个bug，因为必须要把它给修好。"
 *
 * A home that is active in Guesty and has a day missing from our copy of its calendar is not a
 * home with "unknown availability". It is a sync fault, and a sync fault that is quietly hidden
 * is a fault nobody fixes. So this answers in four states, and only one of them is "fine":
 *
 *   'checking' — the calendar has not arrived, or does not yet reach the end of the window
 *   'error'    — the calendar could not be loaded at all
 *   'gaps'     — the calendar arrived and days are missing from it: THE FAULT
 *   'ok'       — every day in the window is there
 *
 * Absence is never a verdict: 'checking' and 'error' are not "ok", and neither is "gaps".
 */

/** How far ahead the Listing checks. A mid-term renter looks one to six months out. */
export const CHECK_DAYS = 180

/**
 * DOES THIS SCREEN JUDGE THE CALENDAR ITSELF, OR DOES THE SERVER?
 *
 * One function, used both by the screen that decides what to draw and by the effect that decides
 * what to read, so the two cannot disagree. They did, and it cost five seconds: with a listing
 * server the Listing screen hands over to the server's own browse answer — which runs this very
 * `calendarCheck` against the server's copy of the nights and reports the fault in
 * `preview.missing` — while the effect went on reading 180 days × every home into the browser for
 * a judgement nothing on the screen used (#646).
 *
 * `stays` and not merely an api object: that is the answer the browse page is drawn from.
 */
export const judgedHere = (previewApi) => !previewApi?.stays

const DAY_MS = 86_400_000
const addDays = (iso, n) => new Date(Date.parse(`${iso}T00:00:00Z`) + n * DAY_MS).toISOString().slice(0, 10)

export function calendarCheck(unit, mirror, { from, days = CHECK_DAYS, error = null, loading = false } = {}) {
  /* An error from an earlier attempt means nothing while a retry is in flight (#58 review). */
  if (loading) error = null
  /* No clock, no window: the check waits rather than read the wall clock itself (#58 review). */
  if (!from) return { state: 'checking' }
  if (!mirror) return error ? { state: 'error' } : { state: 'checking' }
  const last = addDays(from, days - 1)
  if (!mirror.covers(from) || !mirror.covers(last)) return error ? { state: 'error' } : { state: 'checking' }
  const missing = []
  for (let i = 0; i < days; i += 1) {
    const d = addDays(from, i)
    if (mirror.lookup(unit.id, d).missing) missing.push(d)
  }
  return missing.length === 0
    ? { state: 'ok' }
    : { state: 'gaps', missingDays: missing.length, firstMissing: missing[0], lastMissing: missing[missing.length - 1] }
}
